import { c as _c } from "react/compiler-runtime";
import { QAList, type Question } from '../_components/QAList';
const knowledgeDbQuestions: Question[] = [{
  title: 'Mam pewne wątpliwości/ pytania odnośnie przeczytanego artykułu, gdzie mogę się zgłosić?',
  content: <>
        Wszystkie uwagi i pytania można zgłaszać do nas na adres{' '}
        <a href='mailto:kontakt@algoacademy.pl' className='font-bold text-algoprimary hover:underline'>
          kontakt@algoacademy.pl
        </a>{' '}
        lub na naszym serwerze Discord.
      </>
}, {
  title: 'Czy wszystkie materiały w bazie wiedzy są darmowe?',
  content: 'Tak, wszystkie materiały są bezpłatne i dostępne dla każdego.'
}, {
  title: 'Czy planujecie rozszerzyć bazę wiedzy o nowe dziedziny i technologie?',
  content: 'Oczywiście! Nasza baza jest rozwijana każdego dnia. To tylko kwestia czasu aż pojawią się tam nowe sekcje.'
}, {
  title: 'Czy baza wiedzy jest dostępna dla wszystkich użytkowników?',
  content: <>
        Tak! Nasza strona, aplikacja i baza wiedzy są całkowicie darmowe. Płacisz tylko za kursy i
        mentoring, jeśli chcesz z nich skorzystać.
      </>
}, {
  title: 'Czy mogę zaproponować nowy temat do bazy wiedzy?',
  content: <>
        Oczywiście! Jeśli masz pomysł na artykuł, który chciałbyś przeczytać, napisz do nas na{' '}
        <a href='mailto:kontakt@algoacademy.pl' className='font-bold text-algoprimary hover:underline'>
          kontakt@algoacademy.pl
        </a>{' '}
        lub na naszym serwerze Discord. Często dodajemy nowe treści, więc jest duża szansa, że Twój
        temat się pojawi!
      </>
}];
export function QAKnowledgeDbSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <QAList questions={knowledgeDbQuestions} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}